import { createSlice } from "@reduxjs/toolkit";
import { getfacebookAdsList } from "./ThunkActions";
import {  REDUCER_NAME, IFacebookAdsState } from "./Types";

// Define initial state based on the provided structure
const initialState: IFacebookAdsState = {
  isLoading: false,
  facebookAdsList: [],
  errorMessage: null,
};

export const facebookAdsSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetfacebookAdsState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getfacebookAdsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getfacebookAdsList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.facebookAdsList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getfacebookAdsList.rejected, (state) => {
        state.errorMessage = "Failed to fetch Ads list";
        state.isLoading = false;
      });
  },
});

export const { resetfacebookAdsState } = facebookAdsSlice.actions;
export default facebookAdsSlice.reducer;
